<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button previousPageTitle="OAuth2 Scopes" previousPageUrl="/scopes" />
    </glxy-page-nav>
    <glxy-page-title>Edit OAuth2 Scope</glxy-page-title>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <mat-card appearance="outlined">
      <mat-card-content>
        <form *ngIf="!loading" [formGroup]="form" (ngSubmit)="onSubmit()">
          <mat-form-field>
            <input placeholder="scope-id" formControlName="id" matInput />
          </mat-form-field>
          <mat-form-field>
            <input placeholder="Name" formControlName="name" matInput />
          </mat-form-field>
          <mat-form-field>
            <input placeholder="Description" formControlName="description" matInput />
          </mat-form-field>
          <mat-card-actions>
            <button mat-flat-button color="primary" [disabled]="form.invalid || isDisabled">Save</button>
            <button mat-flat-button type="button" (click)="onCancel()">Cancel</button>
          </mat-card-actions>
        </form>
      </mat-card-content>
    </mat-card>
  </glxy-page-wrapper>
</glxy-page>
